import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { MultipleViewTypeListActiveItemPreviewHeaderActions } from '../../../MultipleViewTypeList'
import { PageEmptyState } from '../../../PageEmptyState'
import Text from '../../../Text'
import { QA_NAME_VIEWING_PROFILE_RETRY } from '../RentalPortalViewingProfile.constants'

import RefreshIcon from '../../../../icons/refresh.svg'
import RentalPortalIcon from '../../../../icons/rental-portal.svg'

function RentalPortalViewingProfilePreviewError({
  className,
  openFullPageActionsProps,
  onRetry,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <PageEmptyState EntityIcon={RentalPortalIcon}>
        <Text isSecondary>{t('RentalPortal.ViewingProfileLoadErrorKey')}</Text>
        <Button.Flat
          beforeIconProps={{ Icon: RefreshIcon }}
          qaName={QA_NAME_VIEWING_PROFILE_RETRY}
          text={t('RentalPortal.ListingRetryBtnKey')}
          onClick={onRetry}
        />
        {openFullPageActionsProps ? (
          <MultipleViewTypeListActiveItemPreviewHeaderActions
            {...openFullPageActionsProps}
          />
        ) : null}
      </PageEmptyState>
    </div>
  )
}

export default RentalPortalViewingProfilePreviewError
